import { useState } from 'react';
import { useOrganizationContext } from '../organization.context';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { RotationUploadWizard } from '../../components/upload-contexts/rotation';
import { FEATURES } from 'shared/constants/features.constants';
export default function UploadRotationSlots() {
  const { organization } = useOrganizationContext();
  const [open, setOpen] = useState(false);

  // check if organization exists and feature is enabled
  if (!organization?.features?.includes(FEATURES.ROTATIONS)) {
    return null;
  }

  const dialogDescription = organization?.name;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="w-48">Import Rotation Slots</Button>
      </DialogTrigger>
      <DialogContent className="h-4/5 min-w-[85%] flex flex-col">
        <DialogHeader className="space-y-0 mb-0">
          <DialogTitle>Import Rotation Slots</DialogTitle>
          <DialogDescription>{dialogDescription}</DialogDescription>
        </DialogHeader>
        <RotationUploadWizard />
      </DialogContent>
    </Dialog>
  );
}
